import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2024EvidenciasFotograficas() {
  return <CategoryPage category="anexo30Y31Ano2024EvidenciasFotograficas" pageTitle="Evidencias Fotograficas 2024" />;
}

export default Anexo30Y31Ano2024EvidenciasFotograficas;
